/**
 * Layout - Main app layout with Header and content area
 * Uses Simulacra design system
 */
import React from 'react';
import { YStack } from 'tamagui';
import Header from './Header';

interface LayoutProps {
  children: React.ReactNode;
  isLoggedIn: boolean;
  userEmail?: string;
  onLogout: () => void;
}

export const Layout: React.FC<LayoutProps> = ({ children, isLoggedIn, userEmail, onLogout }) => {
  return (
    <YStack flex={1} backgroundColor="$background" minHeight="100vh">
      <Header isLoggedIn={isLoggedIn} userEmail={userEmail} onLogout={onLogout} />
      <YStack flex={1} width="100%">
        {children}
      </YStack>
    </YStack>
  );
};

export default Layout;
